import request from '@/utils/request'


// 查询接单设置列表
export function listSet(query) {
  return request({
    url: '/order/order-set/list',
    method: 'get',
    params: query
  })
}

// 查询接单设置分页
export function pageSet(query) {
  return request({
    url: '/order/order-set/page',
    method: 'get',
    params: query
  })
}

// 查询接单设置详细
export function getSet(data) {
  return request({
    url: '/order/order-set/detail',
    method: 'get',
    params: data
  })
}

// 新增接单设置
export function addSet(data) {
  return request({
    url: '/order/order-set/add',
    method: 'post',
    data: data
  })
}

// 修改接单设置
export function updateSet(data) {
  return request({
    url: '/order/order-set/edit',
    method: 'post',
    data: data
  })
}

// 删除接单设置
export function delSet(data) {
  return request({
    url: '/order/order-set/delete',
    method: 'post',
    data: data
  })
}
